import { currentRoute, navigate } from '@/router';
import { cartCount } from '@/store/cart';

/**
 * Нижняя навигация мобильной оболочки (фиксирована, safe-area-aware).
 * Четыре ключевых раздела. Остальное (профиль, меню, выход) — в drawer.
 */
const ITEMS = [
  { route: 'dashboard', icon: 'fa-house', label: 'Главная' },
  { route: 'search', icon: 'fa-magnifying-glass', label: 'Каталог' },
  { route: 'cart', icon: 'fa-cart-shopping', label: 'Корзина', badge: true },
  { route: 'orders', icon: 'fa-receipt', label: 'Заказы' },
];

export function MobileBottomNav() {
  const route = currentRoute.value;
  const count = cartCount.value;

  return (
    <nav class="m-bottomnav" aria-label="Основная навигация">
      {ITEMS.map((item) => {
        const active = route === item.route;
        return (
          <button
            key={item.route}
            type="button"
            class={`m-bottomnav-item ${active ? 'is-active' : ''}`}
            onClick={() => navigate(item.route)}
            aria-current={active ? 'page' : undefined}
          >
            <span class="m-bottomnav-icon">
              <i class={`fa-solid ${item.icon}`} />
              {item.badge && count > 0 && (
                <span class="m-bottomnav-badge">{count > 99 ? '99+' : count}</span>
              )}
            </span>
            <span class="m-bottomnav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
